export const MAP_BOX = 'map_box';
export const NEAR_MAP = 'near_map';

export const CUSTOM_MAP = 'custom';
export const get_custom_map_url = url => url;
export const custom_map_max_zoom_level = 20;
